module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Não encontramos seu link de pagamento.","text":"Esse link de pagamento não existe ou expirou.\\nPeça para criarem um novo link."},"en-US":{"title":"We didn\u0027t find your payment link.","text":"This payment link does not exist or has expired.\\nAsk them to create a new link."}}')
  delete Component.options._Ctor
}
